import React, {useContext, useState} from 'react';
import {useTranslation} from "react-i18next";

import InstallerContext from "@/context/InstallerContext";

import Step from "@/components/Step";
import StepTitle from "@/components/StepTitle";
import PrevButton from "@/components/PrevButton";
import NextButton from "@/components/NextButton";
import BackgroundCard from "@/components/BackgroundCard";
import ButtonWrapper from "@/components/ButtonWrapper";
import ErrorMessage from "@/components/ErrorMessage";
import StepDescription from "@/components/StepDescription";
import GameCard from "@/components/GameCard";


const GameSelection = ({nextStep, previousStep}) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const {data, setGame} = useContext(InstallerContext)
  const {game} = data;
  
  const handlePrevStep = (e) => {
    e.preventDefault();
    setGame(null);
    previousStep();
  }
  
  const handleNextStep = (e) => {
    e.preventDefault();
    setLoading(true);
    nextStep();
  };
  
  const disabled = loading || game === null;
  
  return (
      <Step>
        <StepTitle>
          {t('steps.1.title')}
        </StepTitle>
        <StepDescription>
          {t('steps.1.description')}
        </StepDescription>
        
        <ErrorMessage errors={errors}/>
        
        <BackgroundCard>
          <div className="grid grid-cols-2 md:grid-cols-7 gap-4 mb-8 md:mb-0">
            {data.games.map(game =>
                <GameCard key={game.id} id={game.id} name={game.name} image={game.image} selected={data.game === game.id}/>
            )}
          </div>
        </BackgroundCard>
        
        <ButtonWrapper>
          <PrevButton previousStep={handlePrevStep}/>
          <NextButton nextStep={handleNextStep} disabled={disabled} loading={loading}/>
        </ButtonWrapper>
      </Step>
  );
};

export default GameSelection;